export default __webpack_public_path__ + "static/media/browser-wallet-screen.17403ab7.png";